module.exports = __webpack_public_path__ + "static/media/910c69c9-1457-45b2-9db2-09eb4b2921eb.d9e81a98.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274145/910c69c9-1457-45b2-9db2-09eb4b2921eb.eot
// module id = 554
// module chunks = 2